var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.2 71.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #905ea3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.8,29.2h-2v-7.7c0-2.4-.4-4.7-1.1-6.8C44.8,6.1,36.7,0,27.2,0S9.8,6.1,6.9,14.6c-.7,2.1-1.1,4.4-1.1,6.8v7.7h-1.3c-2.5,0-4.5,2-4.5,4.5v33.6c0,2.5,2,4.5,4.5,4.5h46.3c2.5,0,4.5-2,4.5-4.5v-33.6c0-2.5-2-4.5-4.5-4.5ZM31.7,50.3v9.4c0,1.3-1.1,2.4-2.4,2.4h-3.5c-1.3,0-2.4-1.1-2.4-2.4v-9.5c-1-1-1.6-2.4-1.6-3.9,0-3.2,2.6-5.7,5.7-5.7s5.7,2.6,5.7,5.7-.6,3-1.6,4ZM13.7,29.2l.2-7.7c.4-2.6,1.5-4.9,3.1-6.8,2.5-2.9,6.2-4.8,10.3-4.8s7.8,1.8,10.3,4.8c1.6,1.9,2.7,4.2,3.1,6.8v7.7c.1,0-27,0-27,0Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d0f295faffbacf2f3b0db731e33cabfd.svg";
export { ForwardRef as ReactComponent };